export const getIsQAProxy = () => window.location.hostname.indexOf('wthubspot') >= 0;